import React from 'react'
import "./Project.css"
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import ProjectBox from '../../Components/ProjectBox/ProjectBox'
import PrasangImage from '../../Assets/PrasangWebsite.png'
import TankAlertImg from "../../Assets/TankAlert.png"
import LobbyLightImg from "../../Assets/LobbyLights.png"
import MonkeyTypeImg from "../../Assets/MonkeyType.png"
import { useEffect } from 'react'
import MyLoader from "../../Components/Loader/Loader"
function Loaded(){
  document.querySelector(".Loader").style.display = "none";
  document.querySelector(".App-2").style.display = "block";
}
const Project = () => {
  useEffect(() => {
    setTimeout(Loaded, 500);
  }, []);

  return (
    <>
      <MyLoader></MyLoader>
    <div className='App-2'>
      <Navbar></Navbar>
      <div className='Projects'>
        <ProjectBox ProjectName="Prasang Website" ProjectImg={PrasangImage} ProjectLink="/Projects/PrasangWebsite"/>
        <ProjectBox ProjectName="Lobby Light Automation" ProjectImg={LobbyLightImg} ProjectLink="/Projects/LobbyLightAutomation"/>
        <ProjectBox ProjectName="Tank Fill alert to save water" ProjectImg={TankAlertImg} ProjectLink="/Projects/TankAlerter"/>
        <ProjectBox ProjectName="TodoList" ProjectImg="https://i.postimg.cc/PrV1D9KM/Screenshot-2024-02-20-at-2-32-11-AM.png" ProjectLink="/Projects/TodoList"/>
        <ProjectBox ProjectName="Krim Desktop Assistant" ProjectImg="https://i.postimg.cc/PrV1D9KM/Screenshot-2024-02-20-at-2-32-11-AM.png" ProjectLink="/Projects/KrimDesktopAssistant"/>
        <ProjectBox ProjectName="MonkeyType Automation" ProjectImg={MonkeyTypeImg} ProjectLink="/Projects/MonkeytypeAutomation"/>
    </div>
    <Footer></Footer>
    </div>
    </>
  )
}

export default Project
